import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom'
import LoginPage from '../pages/LoginPage'
import SubscriptionPage from '../pages/SubscriptionPage'
import HomePage from '../pages/HomePage'
import AllQuizes from '../pages/AllQuizes'
import QuizDetails from '../pages/QuizDetails'
import Leaderboard from '../pages/Leaderboard'
import Profile from '../pages/Profile'
import ContactUs from '../pages/ContactUs'
import Policy from '../pages/Policy'
import Language from '../pages/Language'
import EditProfile from '../pages/EditProfile'
import History from '../pages/History'
import FindingOpponent from '../pages/FindingOpponent'
import Game from '../pages/Game'
import GameOver from '../pages/GameOver'
import ErrorBoundary from '../pages/ErrorBoundary'
import OtpPage from '../pages/OtpPage'
import ConfirmationPage from '../pages/ConfirmationPage'
import LowBalancePage from '../pages/LowBalancePage'
import PostPaidNumber from '../pages/PostPaidNumber'
import Auth from '../components/Auth'
import DailyPackExpired from '../pages/DailyPackExpired'

const Routes = () => {
    const router = createBrowserRouter([
        {
            path: "/",
            element: <SubscriptionPage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/login",
            element: <LoginPage />,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/postpaid-issue",
            element: <PostPaidNumber />,
            errorElement: <ErrorBoundary />
        },
        {
            path:"/daily-pack-expired",
            element:<DailyPackExpired />,
            errorElement:<ErrorBoundary />
        },
        {
            path: "/otp",
            element: <OtpPage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/confirmation",
            element: <ConfirmationPage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/low-balance",
            element: <LowBalancePage />,
            errorElement: <ErrorBoundary />
        },
        {
            path: "/home",
            element: <Auth>
                <HomePage />
            </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/all-quizes",
            element:
                <Auth>
                    <AllQuizes />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/quiz-details",
            element:
                <Auth>
                    <QuizDetails />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/leaderboard",
            element:
                <Auth>
                    <Leaderboard />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/profile",
            element:
                <Auth>
                    <Profile />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/contact-us",
            element:
                <Auth>
                    <ContactUs />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/policy",
            element:
                <Auth>
                    <Policy />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/language",
            element:
                <Auth>
                    <Language />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/edit-profile",
            element:
                <Auth>
                    <EditProfile />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/history",
            element:
                <Auth>
                    <History />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/finding-opponent",
            element:
                <Auth>
                    <FindingOpponent />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/game",
            element:
                <Auth>
                    <Game />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "/game-over",
            element:
                <Auth>
                    <GameOver />
                </Auth>
            ,
            errorElement: <ErrorBoundary />

        },
        {
            path: "*",
            element: <Navigate to="/" />
        }
    ])
    return (
        <RouterProvider router={router} />
    )
}

export default Routes